import { getServerBaseUrl } from '@/utils/serverUrl'
import { withBearerAuth } from '@/utils/authHeaders'

export type PermissionKey = string

export interface PermissionDefinition {
  key: PermissionKey
  label: string
  description?: string
  category: string
  defaultEnabled?: boolean
}

export interface PermissionDefinitionsByCategory {
  [category: string]: PermissionDefinition[]
}

export interface TierPermissions {
  [permissionKey: string]: boolean
}

class PermissionService {
  private serverBaseUrl: string

  constructor() {
    this.serverBaseUrl = getServerBaseUrl()
  }

  async getDefinitions(): Promise<{ success: boolean; definitions?: PermissionDefinitionsByCategory; error?: string }> {
    try {
      const res = await fetch(`${this.serverBaseUrl}/api/permissions/definitions`, {
        headers: withBearerAuth(),
      })
      const data = await res.json()
      return { success: res.ok, definitions: data.definitions, error: data.error }
    } catch (e: any) {
      return { success: false, error: e.message }
    }
  }

  async getTierPermissions(tierId: string): Promise<{ success: boolean; permissions?: TierPermissions; error?: string }> {
    try {
      const res = await fetch(`${this.serverBaseUrl}/api/permissions/tier/${tierId}`, {
        headers: withBearerAuth(),
      })
      const data = await res.json()
      return { success: res.ok, permissions: data.permissions, error: data.error }
    } catch (e: any) {
      return { success: false, error: e.message }
    }
  }

  async updateTierPermissions(tierId: string, permissions: TierPermissions): Promise<{ success: boolean; error?: string }>{
    try {
      const res = await fetch(`${this.serverBaseUrl}/api/permissions/tier/${tierId}`, {
        method: 'PUT',
        headers: withBearerAuth({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({ permissions })
      })
      const data = await res.json()
      return { success: res.ok && data.success, error: data.error }
    } catch (e: any) {
      return { success: false, error: e.message }
    }
  }
}

export const permissionService = new PermissionService()
export default permissionService


